import storage, { storagekeys } from '@/utils/storage'
import type { CacheUserInfo } from '@/business/login'
import { getStorageUserInfo } from '@/business/login'
import { getStores } from '@/stores'

/** front_api 与 agent 接口统一使用 AuthorizationFront；storage key 使用 aigc_web_* 与 client 隔离 */
export const tokenKey = 'AuthorizationFront'

export const getToken = () => {
  const data = storage.get<CacheUserInfo>(storagekeys.userInfo)
  return data?.userInfo?.token || ''
}

export const getUserInfoByStorage = () => {
  const data = storage.get<CacheUserInfo>(storagekeys.userInfo)
  const token = data?.userInfo?.token || ''
  return {
    token,
    phone: data?.userInfo?.phone,
    name: data?.userInfo?.name,
    userId: data?.userInfo?.user_id,
    selCompanyId: getCompanyExId()
  }
}

/** 当前选中公司 ID（storage + mobx，与 SSE 的 companyexid 一致） */
export const getCompanyExId = () => {
  const data = getStorageUserInfo()
  const { userStore } = getStores()
  return (
    data?.selectedCompanyInfo?.company_ex_id || userStore.selectedCompanyInfo?.company_ex_id || ''
  )
}
